import { UNSAFE_noExposureExp, expValEquals } from '@confluence/feature-experiments';

import {
	BLANK_PAGE_QUICK_ACTIONS_MULTI_VARIANT_COHORTS,
	BLANK_PAGE_QUICK_ACTIONS_SINGLE_VARIANT_COHORTS,
} from './bpqaConst';

/*
 * Eligiblity hook for milestone 1 experiment for BPQA v2
 */
export const getBlankPageQuickActionsExperimentEnabled = ({
	shouldFireExperimentExposure = false,
}: {
	shouldFireExperimentExposure: boolean;
}) => {
	//  Returns the cohort of the tenant: not-enrolled, control, or test
	const [experiment, experimentExposure] = UNSAFE_noExposureExp(
		'confluence_bpqa_v2_milestone1_experiment',
	);
	const cohort = experiment.get(
		'cohort',
		'not-enrolled',
	) as BLANK_PAGE_QUICK_ACTIONS_MULTI_VARIANT_COHORTS;

	shouldFireExperimentExposure && experimentExposure();

	// Returns if the user should see BPQA experiment, do NOT use for exposure events
	const isBPQAExperimentEnabled =
		cohort === BLANK_PAGE_QUICK_ACTIONS_MULTI_VARIANT_COHORTS.VARIANT1 ||
		cohort === BLANK_PAGE_QUICK_ACTIONS_MULTI_VARIANT_COHORTS.VARIANT2;

	return {
		cohort,
		isBPQAExperimentEnabled,
	};
};

/*
 * Eligiblity hook for milestone 2 experiment for BPQA v2
 */
export const getBPQAMilestone2ExperimentEnabled = ({
	shouldFireExperimentExposure = false,
}: {
	shouldFireExperimentExposure: boolean;
}) => {
	//  Returns the cohort of the tenant: not-enrolled, control, or test

	const [experiment, experimentExposure] = UNSAFE_noExposureExp(
		'confluence_bpqa_v2_milestone2_experiment',
	);
	const milestone2Cohort = experiment.get(
		'cohort',
		'not-enrolled',
	) as BLANK_PAGE_QUICK_ACTIONS_SINGLE_VARIANT_COHORTS;

	shouldFireExperimentExposure && experimentExposure();
	// Returns if the user should see BPQA experiment milestone 2, do NOT use for exposure events
	const isBPQAMilestone2ExperimentEnabled =
		milestone2Cohort === BLANK_PAGE_QUICK_ACTIONS_SINGLE_VARIANT_COHORTS.TEST;

	return {
		milestone2Cohort,
		isBPQAMilestone2ExperimentEnabled,
	};
};

/*
 * Eligiblity hook for milestone 3 experiment for BPQA v2
 */
export const getBPQAMilestone3ExperimentEnabled = ({
	shouldFireExperimentExposure = false,
}: {
	shouldFireExperimentExposure: boolean;
}) => {
	//  Returns the cohort of the tenant: not-enrolled, control, or test
	const [experiment, experimentExposure] = UNSAFE_noExposureExp(
		'confluence_bpqa_v2_milestone3_experiment',
	);
	const milestone3Cohort = experiment.get(
		'cohort',
		'not-enrolled',
	) as BLANK_PAGE_QUICK_ACTIONS_SINGLE_VARIANT_COHORTS;

	shouldFireExperimentExposure && experimentExposure();

	// Returns if the user should see BPQA experiment milestone 3, do NOT use for exposure events
	const isBPQAMilestone3ExperimentEnabled =
		milestone3Cohort === BLANK_PAGE_QUICK_ACTIONS_SINGLE_VARIANT_COHORTS.TEST;

	return {
		milestone3Cohort,
		isBPQAMilestone3ExperimentEnabled,
	};
};

// eslint-disable-next-line confluence-feature-gating/inline-usage
export const getSmartButtonBlankPageQuickActionsExperimentEnabled = () =>
	expValEquals('smart_button_blank_page_quick_action', 'cohort', 'smartButton');
